export default "__VITE_ASSET__DRVAf3Tr__"